/**
 * Keep the below two definitions IN SYNC!!!
 */
export enum EntityConfigFieldTypePropertyUri {
  options_options = 'options_options',
  hierarchicalOptions_options = 'hierarchicalOptions_options',
  ordered_rating_options = 'ordered_rating_options',
  text_minCardinanlity = 'text_minCardinanlity',
  text_maxCardinanlity = 'text_maxCardinanlity',
  ordered_rating_formula = 'ordered_rating_formula'
}
export const EntityConfigFieldTypePropertyValueMapper = {
  [EntityConfigFieldTypePropertyUri.options_options]: (value) => JSON.parse(value as string),
  [EntityConfigFieldTypePropertyUri.hierarchicalOptions_options]: (value) => JSON.parse(value as string),
  [EntityConfigFieldTypePropertyUri.ordered_rating_options]: (value) => JSON.parse(value as string),
  [EntityConfigFieldTypePropertyUri.text_minCardinanlity]: (value) => parseInt(value as string, 10),
  [EntityConfigFieldTypePropertyUri.text_maxCardinanlity]: (value) => parseInt(value as string, 10),
  [EntityConfigFieldTypePropertyUri.ordered_rating_formula]: (value) => JSON.parse(value as string)
};
/**
 * End sync
 */
